import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import {
  type DismissJobNotificationRequestPathParams,
  type DismissJobNotificationResponse,
  DismissJobNotificationResponseSchema,
} from '@vy/api-definition';

export function useDismissJobNotification(
  options?: UseMutationOptions<DismissJobNotificationResponse, unknown, DismissJobNotificationRequestPathParams['jobId']>,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (jobId: string) => {
      const api = getPrivateApi();
      const dismissJobNotificationResponse = await api.dismissJobNotification({
        jobId,
      });

      return DismissJobNotificationResponseSchema.parse(dismissJobNotificationResponse);
    },
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.jobs() });

      if (options?.onSuccess) {
        await options.onSuccess(data, variables, context);
      }
    },
    onError: async (error, variables, context) => {
      console.error('Failed to dismiss job notification:', error);

      if (options?.onError) {
        await options.onError(error, variables, context);
      }
    },
  });
}
